import { render } from "./AppSlider.vue?vue&type=template&id=bdf462de&scoped=true"
import script from "./AppSlider.vue?vue&type=script&lang=js"
export * from "./AppSlider.vue?vue&type=script&lang=js"

import "./AppSlider.vue?vue&type=style&index=0&id=bdf462de&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdf462de"]])

export default __exports__